<div
  class="cam-print-wrapper"
  id="prrrnth"
  style="display: none; background-color: #ffffff !important; width: 100% !important; min-width: 100% !important; max-width: 100% !important; height: auto !important; overflow: visible !important; box-sizing: border-box !important;"
>
  <div class="cam-print-container" id="camPrintRoot">
    <!-- Document Header -->
    <div class="cam-print-header">
    <div class="top-row">
      <div class="logo-box">
        <img
          src="{{ EmployeeProfileBaseUrl }}logo.png"
          alt="Company Logo"
          class="company-logo"
        />
      </div>
      <div class="company-details">
        <h3>{{ originalData?.CompanyName || 'FINNAUX TECHSOLUTIONS' }}</h3>
        <p *ngIf="originalData?.CompanyAddress">{{ originalData?.CompanyAddress }}</p>
      </div>
    </div>
    
    <!-- Title Ribbon -->
    <div class="doc-title-bar">
      <h5>CAM REPORT</h5>
    </div>

    <!-- Quick Meta Bar -->
    <div class="cam-quick-meta-bar" *ngIf="resData?.Item1?.[0]">
      <div class="meta-item">
        <span class="meta-label">APPLICATION NO</span>
        <span class="meta-val">{{ resData?.Item1?.[0]?.Application_No || '-' }}</span>
      </div>
      <div class="meta-item" *ngIf="borrowerName">
        <span class="meta-label">BORROWER</span>
        <span class="meta-val">{{ borrowerName }}</span>
      </div>
      <div class="meta-item">
        <span class="meta-label">LOAN ACCOUNT NO</span>
        <span class="meta-val">{{ resData?.Item1?.[0]?.LoanAcNo || '-' }}</span>
      </div>
      <div class="meta-item">
        <span class="meta-label">LOAN DATE</span>
        <span class="meta-val">{{ resData?.Item1?.[0]?.Loan_Date || '-' }}</span>
      </div>
      <div class="meta-item">
        <span class="meta-label">PRODUCT</span>
        <span class="meta-val">{{ resData?.Item1?.[0]?.Product_Name || '-' }}</span>
      </div>
      <div class="meta-item">
        <span class="meta-label">BRANCH</span>
        <span class="meta-val">{{ resData?.Item1?.[0]?.Branch_Name || '-' }}</span>
      </div>
    </div>
  </div>

  <!-- Loan Details -->
  <div class="cam-print-section" *ngIf="resData?.Item1?.length">
    <div class="cam-section-banner">
      <i class="fas fa-info-circle"></i>
      <span class="titleHeadP">Loan Details</span>
    </div>
    <div class="cam-card-container">
      <app-loan-subcard-info
        [loandata]="resData?.Item1[0]"
      ></app-loan-subcard-info>
    </div>
  </div>

  <!-- Financial Details -->
  <div class="cam-print-section" *ngIf="resData?.Item16?.length">
    <div class="cam-section-banner">
      <i class="fas fa-coins"></i>
      <span class="titleHeadP">Financial Details</span>
    </div>
    <div class="cam-card-container">
      <app-loan-financial-info
        [financialdata]="resData?.Item16"
      ></app-loan-financial-info>
    </div>
  </div>

  <!-- Asset Details -->
  <div class="cam-print-section" *ngIf="resData?.asset?.[0]?.Product_Category === 'Vehicle Loan' || resData?.asset?.[0]?.Product_Category === 'Property Loan' || resData?.goldAsset?.length || resData?.LegalAssets?.length || resData?.ValuationAssestsDetails?.length">
    <div class="cam-section-banner">
      <i class="fas fa-building"></i>
      <span class="titleHeadP">Asset Details</span>
    </div>
    <div class="cam-card-container">
      <app-asset-subcard-info
        [assetData]="resData?.asset[0]"
        [AssetsAttachment]="resData?.AssetsAttachment"
        [ApplicationNumber]="resData?.ApplicationNumber?.[0]"
        [GoldAssets]="resData?.goldAsset"
        [LegalAssets]="resData?.LegalAssets"
        [ValuationAssestsDetails]="resData?.ValuationAssestsDetails"
        [ValuationAttachments]="resData?.ValuationAttachments"
      ></app-asset-subcard-info>
    </div>
  </div>

  <!-- TAT Details -->
  <div class="cam-print-section" *ngIf="loanId">
    <div class="cam-section-banner">
      <i class="fas fa-stopwatch"></i>
      <span class="titleHeadP">TAT Details</span>
    </div>
    <div class="cam-card-container">
      <app-tat-report [loanId]="loanId"></app-tat-report>
    </div>
  </div>

  <!-- Deduction Details -->
  <div class="cam-print-section" *ngIf="loanId">
    <div class="cam-section-banner">
      <i class="fas fa-receipt"></i>
      <span class="titleHeadP">Deduction Details</span>
    </div>
    <div class="cam-card-container">
      <app-receipt-deduction [loanId]="loanId"></app-receipt-deduction>
    </div>
  </div>

  <!-- Deviation Details -->
  <div class="cam-print-section" *ngIf="resData?.deviation?.length">
    <div class="cam-section-banner">
      <i class="fas fa-exclamation-triangle"></i>
      <span class="titleHeadP">Deviation Details</span>
    </div>
    <div class="cam-card-container">
      <app-deviation-info [data]="resData?.deviation"></app-deviation-info>
    </div>
  </div>

  <!-- Sanction Conditions -->
  <div class="cam-print-section" *ngIf="resData?.sanction?.length">
    <div class="cam-section-banner">
      <i class="fas fa-clipboard-check"></i>
      <span class="titleHeadP">Sanction Condition</span>
    </div>
    <div class="cam-card-container">
      <app-sanction-condition [data]="resData?.sanction"></app-sanction-condition>
    </div>
  </div>

  <!-- Documents -->
  <div class="cam-print-section" *ngIf="resData?.documents?.length">
    <div class="cam-section-banner">
      <i class="fas fa-folder-open"></i>
      <span class="titleHeadP">Documents & Attachments</span>
    </div>
    <div class="cam-card-container">
      <app-attached-document
        [loanId]="loanId"
        [ApplicationNumber]="resData?.ApplicationNumber?.[0]"
      ></app-attached-document>
    </div>
  </div>

  <!-- FOIR Details -->
  <div class="cam-print-section" *ngIf="loanId">
    <div class="cam-section-banner">
      <i class="fas fa-calculator"></i>
      <span class="titleHeadP">FOIR Details</span>
    </div>
    <div class="cam-card-container">
      <app-foir-card [loanId]="loanId"></app-foir-card>
    </div>
  </div>

  <!-- Recommendation Details -->
  <div class="cam-print-section" *ngIf="resData?.recommendation?.length">
    <div class="cam-section-banner">
      <i class="fas fa-user-check"></i>
      <span class="titleHeadP">Recommendation Details</span>
    </div>
    <div class="cam-card-container">
      <app-recommendation-card-details [data]="resData?.recommendation"></app-recommendation-card-details>
    </div>
  </div>

  <!-- Applicant Details & Verification (Full 3-Column Modern Grid) -->
  <div class="cam-print-section" *ngIf="resData?.data?.length">
    <div class="cam-section-banner">
      <i class="fas fa-users"></i>
      <span class="titleHeadP">Applicant Details & Verification</span>
    </div>

    <div *ngFor="let item of resData?.data; let ind = index" class="applicant-print-block">
      <div class="applicant-title-tag">
        <i class="fas fa-user-tie mr-1"></i>
        <span>
          Applicant #{{ ind + 1 }}
          ({{ item.Item2?.AC_CustomerType == 'H' ? 'Borrower' : (item.Item2?.AC_CustomerType == 'C' ? 'Co-Borrower' : (item.Item2?.AC_CustomerType == 'G' ? 'Guarantor' : 'Applicant')) }})
          — {{ item.Item2?.CustomerName || 'Profile & Verification Records' }}
        </span>
      </div>

      <!-- Row 1: Profile | KYC | CRC -->
      <div class="row my-2 align-items-start applicant-subcard-row">
        <div class="col-4 p-1 subcard-col-3" *ngIf="resData.data[ind]?.Item2">
          <app-customer-subcard-info
            [customerData]="resData.data[ind].Item2"
          ></app-customer-subcard-info>
        </div>
        <div class="col-4 p-1 subcard-col-3" *ngIf="resData.data[ind]?.Item9?.length">
          <app-customer-kyc-subcard-info
            [customerkycData]="resData.data[ind].Item9"
          ></app-customer-kyc-subcard-info>
        </div>
        <div class="col-4 p-1 subcard-col-3" *ngIf="resData.data[ind]?.Item3?.length">
          <app-crc-subcard-info
            [applicationId]="applicationId"
            [crcData]="resData.data[ind].Item3"
            [index]="ind"
          ></app-crc-subcard-info>
        </div>
      </div>

      <!-- Row 2: Family | Income | References -->
      <div class="row my-2 align-items-start applicant-subcard-row">
        <div class="col-4 p-1 subcard-col-3" *ngIf="resData.data[ind]?.Item4?.length">
          <app-family-subcard-info
            [familyData]="resData.data[ind].Item4"
          ></app-family-subcard-info>
        </div>
        <div class="col-4 p-1 subcard-col-3" *ngIf="resData.data[ind]?.Item5?.length">
          <app-income-subcard-info
            [incomeData]="resData.data[ind].Item5"
            [applicationNo]="applicationId"
          ></app-income-subcard-info>
        </div>
        <div class="col-4 p-1 subcard-col-3" *ngIf="resData.data[ind]?.Item6?.length">
          <app-references-subcard-info
            [referenceData]="resData.data[ind].Item6"
          ></app-references-subcard-info>
        </div>
      </div>

      <!-- Row 3: FI | TVR | PD -->
      <div class="row my-2 align-items-start applicant-subcard-row">
        <div class="col-4 p-1 subcard-col-3" *ngIf="resData.data[ind]?.Item10?.length">
          <app-FI-Question-subcard-info
            [FIQuestionData]="resData.data[ind].Item10"
          ></app-FI-Question-subcard-info>
        </div>
        <div class="col-4 p-1 subcard-col-3" *ngIf="resData.data[ind]?.Item11?.length">
          <app-TVR-Question-subcard-info
            [TVRQuestionData]="resData.data[ind].Item11"
          ></app-TVR-Question-subcard-info>
        </div>
        <div class="col-4 p-1 subcard-col-3" *ngIf="resData.data[ind]?.Item12?.length">
          <app-PD-Question-subcard-info
            [PDQuestionData]="resData.data[ind].Item12"
          ></app-PD-Question-subcard-info>
        </div>
      </div>

      <!-- Row 4: PDC / Cheque (if exists) -->
      <div class="row my-2 align-items-start applicant-subcard-row" *ngIf="resData.data[ind]?.Item13?.length">
        <div class="col-4 p-1 subcard-col-3">
          <app-pdc-details
            [PDCDetail]="resData.data[ind].Item13"
          ></app-pdc-details>
        </div>
      </div>
    </div>
  </div>


  </div>
</div>

<!-- Print Trigger Button -->
<button
  type="button"
  class="font-size-12 button-btn ml-2"
  useExistingCss="true"
  bodyClass="cam-print-body cam-print-container"
  printTitle="CAM_Report"
  printSectionId="prrrnth"
  ngxPrint
>
  <i class="fas fa-print mr-1"></i> Print CAM Report
</button>
